import React from 'react';
import { BtnGroup } from 'components/Forms/BtnGroup/BtnGroup.styled';
import { Button } from '@zendeskgarden/react-buttons';
import { Row, Col } from '@zendeskgarden/react-grid';
import { Form } from 'components/Forms/Forms.styled';
import { InputField } from 'components/Forms/Fields';
import LoadingHolder from 'components/LoadingHolder';
import { Separator } from 'containers/AgroBRF/Cadec/Cadec.styled';
import { colorTertiary } from 'components/GlobalStyles/variables';
import t from 'components/i18n';

export default function ChangeDateForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setDisplayCalendar,
    isLoading,
    values,
    errors,
    touched,
  } = props;

  return (
    <>
      <LoadingHolder
        message={t('global.loading')}
        isLoading={isLoading}
      />
      {!isLoading && (
        <Form autoComplete="off">
          <Row>
            <Col md={12}>
              {/* Data de início */}
              <InputField
                type="date"
                field="newDate"
                label={t('form.next.logBook.changeDateForm.field.newDate.label')}
                placeholder={t('form.next.logBook.changeDateForm.field.newDate.placeholder')}
                onChange={handleChange}
                onBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
              {/* \Data de início */}
            </Col>
          </Row>

          <Separator />

          {/* \ Botões */}
          <BtnGroup color={colorTertiary}>
            <Button
              key="sendtoConfirm"
              onClick={() => {
                handleSubmit();
              }}
              disabled={!props.isValid || props.isUploading}
            >
              {t("global.button.save")}
            </Button>
            <Button
              key="clean"
              onClick={() => setDisplayCalendar(false)}
              className="white"
            >
              {t('global.button.cancel')}
            </Button>
          </BtnGroup>
          {/* \ Botões */}
        </Form>
      )}
    </>
  );
}
